import { DocumentSegmentActionTypes, All } from '../actions/documentSegment.actions';
import { DocumentSegment, RequestStatus } from '@app/shared';

// define State interface
export interface State {
  // is a user authenticated?
  selectedDocumentSegment: DocumentSegment | null;
  // if authenticated, there should be a user object
  documentSegments: DocumentSegment[] | null;
  errorStatus: RequestStatus | null;
  successStatus: RequestStatus | null;
  isEditing: boolean | null;
  actionType: string | null;
  themes:any[] | null;
  preferences:any[] | null;
}

// define initial state
export const initialState: State = {

  selectedDocumentSegment: null,
  documentSegments: null,
  successStatus: null,
  errorStatus: null,
  isEditing:false,
  actionType:null,
  themes:null,
  preferences:null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENTS_SUCCESS: {
      return {
        ...state,
        selectedDocumentSegment: null,
        documentSegments: action.payload.documentSegments,
        errorStatus:null,
        successStatus:null,
        actionType:action.type,
      };
    }

    case DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENT_SUCCESS: {
      return {
        ...state,
        selectedDocumentSegment: action.payload.documentSegment,
        errorStatus:null,
        actionType:action.type,
      };
    }

    case DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT: {
      return {
        ...state,
        selectedDocumentSegment: action.payload.documentSegment,
        actionType:action.type,
      };
    }
    case DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_LOCK_SUCCESS: {
      return {
        ...state,
        successStatus:action.payload.successStatus,
        actionType:action.type,
      };
    }case DocumentSegmentActionTypes.UPDATE_DOCUMENT_SEGMENT_SUCCESS: {
      return {
        ...state,
        successStatus:action.payload.successStatus,
        actionType:action.type,
      };
    }
    case DocumentSegmentActionTypes.CREATE_DOCUMENT_SEGMENT:
    case DocumentSegmentActionTypes.EDIT_DOCUMENT_SEGMENT: {
      return {
        ...state,
        selectedDocumentSegment: action.payload.documentSegment,
        isEditing: action.payload.isEditing,
        actionType:action.type,
      };
    }
    case DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_LOCK_FAILURE:
    case DocumentSegmentActionTypes.UPDATE_DOCUMENT_SEGMENT_FAILURE:
    case DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_FAILURE:
    case DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENTS_FAILURE: {
      return {
        ...state,
        errorStatus: action.payload.errorStatus,
        actionType:action.type,
      };
    }
    case DocumentSegmentActionTypes.GET_ALT_FIELDS_SUCCESS: {
      return {
        ...state,
        themes: action.payload.altFields,
        actionType:action.type,
      }
    }
    case DocumentSegmentActionTypes.GET_PREFERENCES_SUCCESS: {	
      return {	
        ...state,		
        actionType:action.type,	
        preferences: action.payload.preferences,
      }	
    }
    default: {
      return {
        ...state,
        actionType:null,
      };
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/documentSegment.reducer.ts